import { LessonType, SentenceType } from "App.types";
import React, { FC } from "react";
import { Flex } from "antd";
import DialogTaskWriting from "./DialogTaskWriting";
import styles from "./DialogTaskTranslate.module.scss";

const DialogTaskText: FC<{
  description?: string;
  sentence: SentenceType;
  onSuccess: Function;
  storyId: number | undefined;
  lesson: LessonType;
}> = ({ storyId, description, sentence: { isLeft }, sentence, onSuccess, lesson }) => {
  // const onHint = useCallback(() => {
  //   API.sentence
  //     .hint(sentence.id, userText, storyId, description)
  //     .then(({ hint }) => notifyApi.info({ message: <div dangerouslySetInnerHTML={{ __html: hint }} />, duration: 10 }));
  // }, [description, notifyApi, sentence.id, storyId, userText]);

  return (
    <div className={styles.dialogTaskTranslate}>
      <Flex gap={5} style={{ flexDirection: isLeft ? "row-reverse" : undefined }}>
        <DialogTaskWriting storyId={storyId} taskDescription={description} sentence={sentence} lesson={lesson} onTaskComplete={onSuccess} />
      </Flex>
    </div>
  );
};

export default React.memo(DialogTaskText);
